@if (shoutPlus) {
<div class="relative isolate min-h-full w-full overflow-y-auto bg-black px-6 pb-20 pt-10 text-white lg:px-10">
    <div aria-hidden="true" class="pointer-events-none absolute inset-x-0 top-0 -z-10 h-96 bg-[radial-gradient(60%_60%_at_70%_0%,rgb(139_92_246/0.22),transparent_70%),radial-gradient(40%_50%_at_10%_10%,rgb(251_191_36/0.12),transparent_70%)]"></div>

    <div class="mx-auto w-full max-w-6xl">
        <div class="flex items-center justify-between gap-4">
            <img src="assets/images/plus/SHOUT_plus_logo_white.svg" alt="SHOUT+" class="h-8 w-auto sm:h-10">
            <a routerLink="/shout-plus-intro"
                class="inline-flex items-center gap-1.5 rounded-full border border-white/25 px-4 py-2 text-sm font-medium text-white hover:bg-white/10 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" class="size-4" aria-hidden="true"><path d="m15 18-6-6 6-6" /></svg>
                Back to SHOUT+
            </a>
        </div>

        <div class="mt-14 grid gap-10 lg:mt-20 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] lg:gap-14">
            <div class="max-w-xl">
                <p class="m-0 inline-flex items-center gap-2 rounded-full bg-amber-400/15 px-3 py-1 text-xs font-semibold text-amber-400">SHOUT+ demo</p>
                <h1 class="m-0 mt-5 text-4xl font-semibold leading-tight sm:text-5xl">Book a demo</h1>
                <p class="m-0 mt-5 text-base leading-relaxed text-white/70 sm:text-lg">
                    See how SHOUT+ turns your customers and team into advocates. We'll walk you through briefs,
                    approvals, rewards and reporting, and set it up around your brand.
                </p>
                <ul class="m-0 mt-8 flex list-none flex-col gap-3 p-0 text-sm text-white/80">
                    <li class="flex items-start gap-3"><span class="mt-1.5 size-1.5 shrink-0 rounded-full bg-amber-400"></span>Invite customers and employees with your own branded link</li>
                    <li class="flex items-start gap-3"><span class="mt-1.5 size-1.5 shrink-0 rounded-full bg-amber-400"></span>Reward with cash, free products or unique discount codes</li>
                    <li class="flex items-start gap-3"><span class="mt-1.5 size-1.5 shrink-0 rounded-full bg-amber-400"></span>Approve who takes part and track what they create</li>
                </ul>
                <p class="m-0 mt-8 text-sm text-white/50">30-minute call · no commitment</p>
            </div>

            <div class="w-full overflow-hidden rounded-3xl">
                <div class="meetings-iframe-container"
                    data-src="https://meetings-eu1.hubspot.com/joshparamor/demo-with-josh?embed=true">
                </div>
            </div>
        </div>
    </div>
</div>
} @else {
<div class="relative isolate h-full w-full flex flex-col p-2 sm:p-6">

    <div class="mx-auto max-w-7xl w-full h-full flex flex-col gap-y-2 sm:gap-y-4 items-start overflow-hidden">
        <div aria-hidden="true"
            class="hidden sm:absolute sm:-top-10 sm:right-1/2 sm:-z-10 sm:mr-10 sm:block sm:transform-gpu sm:blur-3xl">
            <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                class="aspect-1097/845 w-274.25 bg-linear-to-tr from-[#ff4694] to-[#776fff] opacity-20"></div>
        </div>

        <div class="z-10 flex flex-col h-full w-full overflow-hidden">

            <div
                class="w-full min-h-0 flex flex-col items-start justify-start px-4 sm:px-6 flex-1 overflow-y-auto scrollbar-transparent pt-10 pb-24 sm:pb-32 lg:flex lg:px-8 lg:py-40">

                <div class="w-full flex justify-between items-center">
                    <img src="../assets/logos/official/SHOUT_studio_logo_full_colour_black.svg"
                        class="h-8 sm:h-12 w-auto dark:hidden" alt="">
                    <img src="../assets/logos/official/SHOUT_studio_logo_full_colour_white.svg"
                        class="h-8 sm:h-12 w-auto hidden dark:block" alt="">

                    <button routerLink="/onboarding-select" type="button" class="primary-go-button">
                        Back to Register
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-4">
                            <path d="M9 14 4 9l5-5" />
                            <path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11" />
                        </svg>
                    </button>
                </div>


                <div class="mt-24 sm:mt-32 lg:mt-16 w-full">
                    <h2 class="text-base/7 font-semibold text-accent">Take a Tour</h2>
                    <h2
                        class="text-2xl font-semibold tracking-tight text-balance text-primary sm:text-4xl md:text-5xl text-left use-grotesque">
                        Book a
                        <span
                            class="bg-gradient-to-r from-primary to-brand-studio bg-clip-text text-transparent">Call</span>...
                    </h2>
                    <p class="mt-2 text-lg/8 text-gray-700 dark:text-gray-300">Book a call with our team to get a tour
                        of the platform. Let's see how SHOUT can work for you. We're here to help.</p>



                    <div class="meetings-iframe-container"
                        data-src="https://meetings-eu1.hubspot.com/joshparamor/demo-with-josh?embed=true">
                    </div>

                </div>
            </div>


        </div>

        <div aria-hidden="true"
            class="absolute -top-52 left-1/2 -z-10 -translate-x-1/2 transform-gpu blur-3xl sm:-top-112 sm:ml-16 sm:translate-x-0">
            <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                class="aspect-1097/845 w-274.25 bg-linear-to-tr from-[#ff4694] to-[#776fff] opacity-20"></div>
        </div>
    </div>
</div>
}
